import { render, staticRenderFns } from "./PaginationNoneLayout.vue?vue&type=template&id=1c8287c8&scoped=true"
import script from "./PaginationNoneLayout.vue?vue&type=script&lang=js"
export * from "./PaginationNoneLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8287c8",
  null
  
)

export default component.exports